import React from "react";
import DefaultCurrencyFormat from "../calendar/DefaultCurrencyFormat";

const PriceSection = ({ originalPrice, Symbol }) => (
  <div className="flex flex-col">
    <div className="flex flex-row items-center gap-2 xlg:flex-col xlg:items-start xlg:gap-0">
      {/* <span className="text-sm font-medium leading-normal line-through text-themeSecondary">
                ₺{discountedPrice}
            </span> */}
      <span className="text-xl not-italic font-medium leading-normal text-themeBlack">
        <DefaultCurrencyFormat value={originalPrice} Symbol={Symbol} />
      </span>
    </div>
    <span className="text-[#9CA5B0] text-size-11 font-medium leading-normal -tracking--letterS">
      ‘den başlayan gecelik fiyatlar
    </span>
  </div>
);

export default PriceSection;
